import {
    INICIA_ACESSO_FULL,
    SALVA_ACESSO_FULL,
    REMOVE_ACESSO_FULL,
    NOVO_ACESSO_FULL,
    BUSCA_ACESSO_FULL_EDICAO,
    INICIO_ACESSO_FULL_SUCESSO,
    LISTA_CONFIGURACAO_PONTO_FULL,
    LISTA_CONFIGURACAO_PONTO_FULL_SUCESSO,
    LISTA_LOCAIS_POR_CLIENTE_ACESSO_FULL,
    LISTA_LOCAIS_SUCESSO_ACESSO_FULL,
    ALTERACAO_CHECK_PONTO_ACESSO_FULL,
    SALVA_ACESSO_FULL_SUCESSO,
    REMOVE_ACESSO_FULL_SUCESSO,
    BUSCA_ACESSO_FULL_EDICAO_SUCESSO,
    ON_SHOW_LOADER,
    SHOW_MESSAGE,
    HIDE_MESSAGE,
    CONSULTA_CPF,
    CONSULTA_CPF_SUCESSO_FULL,
    LISTA_ACESSO_FULL,
    LISTA_ACESSO_FULL_SUCESSO,
    LIMPAR_ACESSO_FULL
  } from 'constants/ActionTypes';
  
  /*#############################################################################################*/
  /* ------------------------------ Actions Fundamentais CRUD -----------------------------------*/
  
  export const iniciaAcessoFull = () => {
    return {
      type: INICIA_ACESSO_FULL
    };
  };
  
  export const salvaAcessoFull = (acessoFull) => {
    var listaPontosAssociados = [];

    if(acessoFull.configuracaoPontoPessoa != null && acessoFull.configuracaoPontoPessoa.listaAmbientesVinculados != null)
    {
      for (var i = 0; i < acessoFull.configuracaoPontoPessoa.listaAmbientesVinculados.length; i++) {
        var listaPontos = acessoFull.configuracaoPontoPessoa.listaAmbientesVinculados[i].pontosAcessoVinculados;
  
        for (var j = 0; j < listaPontos.length; j++) {
          var idPontoAcesso = listaPontos[j].idPontoAcesso;
          listaPontosAssociados.push({"idPontoAcesso": listaPontos[j].idPontoAcesso, "associado": listaPontos[j].associado })
        }
      }
    }
   
    return {
      type: SALVA_ACESSO_FULL,
      payload: { acessoFull, listaPontosAssociados } 
    };
  };
  
  export const removeAcessoFull = (id) => {
    return {
      type: REMOVE_ACESSO_FULL,
      payload: id
    };
  };
  
  export const listaAcessoFull = (usuario, ambiente, ponto) => {
    if(usuario == undefined){
      usuario = "";
    }
  
    if(ambiente == undefined){
      ambiente = "";
    }
  
    if(ponto == undefined){
      ponto = "";
    }
  
    return {
      type: LISTA_ACESSO_FULL,
      payload: {usuario, ambiente, ponto}
    };
  };
  
  /*#############################################################################################*/
  /* ---------------------------- Actions do Fluxo de Navegação ---------------------------------*/
  
  export const novoAcessoFull = () => {
    return {
      type: NOVO_ACESSO_FULL
    };
  };
  
  export const buscaAcessoFullEdicao = (id) => {
    return {
      type: BUSCA_ACESSO_FULL_EDICAO,
      payload: id
    };
  };
  
  /*#############################################################################################*/
  /* --------------------------- Actions de respostas actions anteriores ------------------------*/  

  export const listaLocaisPorCliente = (name, object, value) => {
    var idCliente = value !== null ? value.id : 0;

    return {
      type: LISTA_LOCAIS_POR_CLIENTE_ACESSO_FULL,
      payload: { idCliente }
    }
  }

  export const consultaCpfSucesso = (correspondenciaCpf) => {
    return {
      type: CONSULTA_CPF_SUCESSO_FULL,
      payload: correspondenciaCpf
    }
  };  

  export const listaConfiguracaoPontosPorPessoa = (idLocal, idPessoa) => {
    return {
      type: LISTA_CONFIGURACAO_PONTO_FULL,
      payload: { idLocal, idPessoa }
    }
  }

  export const onChangeCheckPontoAcesso = (object, value) => {
    var nomeCheck = [object.target.id].toString();
    var idPtoAcesso = nomeCheck.replace(/pontoAcesso_/g, "");

    return {
        type: ALTERACAO_CHECK_PONTO_ACESSO_FULL,
        payload: { idPontoAcessoAlterado: idPtoAcesso, valor: value }
    }   
};   
  
  export const inicioAcessoFullSucesso = (acessosFull, clientes, locais) => {
    return {
      type: INICIO_ACESSO_FULL_SUCESSO,
      payload: { acessosFull, clientes, locais }
    }
  };
  
  export const salvaAcessoFullSucesso = (mensagem) => {
    return {
      type: SALVA_ACESSO_FULL_SUCESSO,
      payload: mensagem
    }
  };
  
  export const removeAcessoFullSucesso = (mensagem) => {
    return {
      type: REMOVE_ACESSO_FULL_SUCESSO,
      payload: mensagem
    }
  };  

  export const listaConfiguracaoPontoPessoaSucesso = (configuracao) => {
    return {
      type: LISTA_CONFIGURACAO_PONTO_FULL_SUCESSO,
      payload: { configuracao }
    }
  }
  
  export const buscaAcessoFullEdicaoSucesso = (acessoFull, locais) => {
    return {
      type: BUSCA_ACESSO_FULL_EDICAO_SUCESSO,
      payload: {acessoFull, locais}
    };
  }; 

  export const listaLocaisSucesso = (locais) => {
    return {
      type: LISTA_LOCAIS_SUCESSO_ACESSO_FULL,
      payload: { locais }
    };
  };

  export const listaAcessoFullSucesso = (acessoFull) => {
    return {
      type: LISTA_ACESSO_FULL_SUCESSO,
      payload: { acessoFull }
    };
  };
  
  export const limparFiltroAcessoFull = () => {
    return {
      type: LIMPAR_ACESSO_FULL,
    };
  };
  
  
  /*#############################################################################################*/
  /* ---------------------------------- Outras Actions Auxiliares -------------------------------*/ 

  export const consultaCPF = (cpf) => {
    let cpfAjustado = cpf.target.value;
    cpfAjustado = cpfAjustado.replace(/-/g, "");

    return {
      type: CONSULTA_CPF,
      payload: cpfAjustado
    };
  };
  
  export const exibirMensagemErro = (message) => {
    return {
      type: SHOW_MESSAGE,
      payload: message
    };
  };
  
  export const showAuthLoader = () => {
    return {
      type: ON_SHOW_LOADER,
    };
  };
  
  export const hideMessage = () => {
    return {
      type: HIDE_MESSAGE,
    };
  };
  
  export const showAuthMessage = (message) => {
    return {
      type: SHOW_MESSAGE,
      payload: message
    };
  };